import { useTranslation } from 'react-i18next';
import { LiliNumberInput } from '@lili/lili-frontend-common';
import { EmailInput } from '@Components/inputs/EmailInput';
import { OnboardingFormFields } from '@Types/index';
import { ControllerWrapper } from '@Hooks/index';
import { FirstNameInput } from '@Components/inputs/FirstNameInput';
import { LastNameInput } from '@Components/inputs/LastNameInput';
import { getRouteOrdinal, RoutesMap } from '@Router/router.types';
import { UBOResidencyToggle } from './UBOResidencyToggle';

export const UBOBasicInfoSection = () => {
  const { t } = useTranslation();
  const baseTabIndex = getRouteOrdinal(RoutesMap.ADD_OWNER);

  return (
    <div className='w-full grid grid-cols-1 sm:grid-cols-2 gap-x-[24px]'>
      <FirstNameInput tabIndex={baseTabIndex + 1} />
      <LastNameInput tabIndex={baseTabIndex + 2} />
      <EmailInput tabIndex={baseTabIndex + 3} />

      <ControllerWrapper name={OnboardingFormFields.OWNER_PERCENTAGE}>
        {({ value, onBlur, onChange, error }) => (
          <LiliNumberInput
            id={OnboardingFormFields.OWNER_PERCENTAGE}
            data-testid={OnboardingFormFields.OWNER_PERCENTAGE}
            title={t('pages.addOwner.ownerAccessSection.ownershipPercentageInput')}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            errorMessage={error?.message}
            min={0}
            max={100}
            suffix='%'
            maxLength={3}
            isPublic
            tabIndex={baseTabIndex + 4}
          />
        )}
      </ControllerWrapper>
      <UBOResidencyToggle />
    </div>
  );
};
